import React from "react";

interface Props extends React.ImgHTMLAttributes<HTMLImageElement> {
  svgString: string;
}

const SvgFromString = ({ svgString, color, ...otherImgProps }: Props) => {
  const coloredSvgString = !!color ? svgString.replace(/fill=".*?"/g, `fill="${color}"`) : svgString;

  const base64String = btoa(coloredSvgString);

  return (
    <>
      {!!base64String && (
        <img
          width={otherImgProps.width ?? "20"}
          src={`data:image/svg+xml;base64,${base64String}`}
          alt="icon"
          {...otherImgProps}
        />
      )}
    </>
  );
};

export default SvgFromString;
